import script from "./myContentsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./myContentsPage.vue?vue&type=script&setup=true&lang=js"

import "./myContentsPage.vue?vue&type=style&index=0&id=62b6540c&scoped=true&lang=scss"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b6540c"]])

export default __exports__